import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgcCommonModule } from '../../common/common.module';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
import { FlyoutLangselectorComponent } from '../../flyout/flyout-langselector/flyout-langselector.component';
import { FlyoutLangselectorModule } from '../../flyout/flyout-langselector/flyout-langselector.module';
// This Module's Components
import { LanguageSelectorComponent } from './language-selector.component';

@NgModule({
  imports: [
    CommonModule,
    DataLayerModule,
    ModalModule.forRoot(),
    FlyoutLangselectorModule,
    NgcCommonModule
  ],
  declarations: [LanguageSelectorComponent],
  exports: [LanguageSelectorComponent]
})
export class LanguageSelectorModule {}
